/**
 * Pre-compiled es messages for SearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearInput: `Borrar entrada de búsqueda` };
